import AlertPanel from 'ext-ui/components/AlertPanel/AlertPanel'
import AlertShieldIcon from 'ext-ui/svg/icon/AlertShieldIcon'
import React, { ReactElement, ReactNode } from 'react'
import style from 'src/feature/CVSVerificationHomepageAlert/CVSVerificationHomepageAlert.style'
import { useTranslate } from 'src/localization/Trns'

type LinkRenderProps = {
  className: string
  'aria-label': string
  children: ReactNode
}

type CVSVerificationHomepageAlertProps = {
  className?: string
  renderLink: (linkProps: LinkRenderProps) => ReactElement
}

function CVSVerificationHomepageAlert(
  props: CVSVerificationHomepageAlertProps,
): ReactElement {
  const { className = '', renderLink } = props
  const translate = useTranslate()

  return (
    <AlertPanel variant="severe-wcag" className={className}>
      <div className="CVSVerificationHomepageAlert" css={style}>
        <div className="icon-column">
          <AlertShieldIcon />
        </div>
        <div className="content-column">
          <p className="title">
            {translate('Verification required for your added security')}
          </p>
          <p>
            {translate('Please complete your ')}
            {renderLink({
              className: 'link',
              'aria-label': translate('card enrollment'),
              children: translate('card enrollment'),
            })}
            {translate(' to enable physical card transactions')}
          </p>
        </div>
      </div>
    </AlertPanel>
  )
}

export default CVSVerificationHomepageAlert
